import { getUser } from "@faire/retailer-visitor-shared/serialized-data/getUser";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { UserRole } from "@faire/web-api--source/indigofair/data/UserRole";
var allowedRoles = [
    UserRole.MAKER,
    UserRole.MAKER_EDITOR
];
var intersection = function(array1, array2) {
    return array1.filter(function(allowedRole) {
        return array2.includes(allowedRole);
    });
};
/**
 * @deprecated Use `useIsBrandPreview` instead
 */ export var getIsBrandPreview = function() {
    var _getUser;
    if (getGlobalProperty("editingAsBrandToken")) {
        return true;
    }
    var roles = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.roles;
    return areUserRolesAllowed(roles);
};
export var useIsBrandPreview = function() {
    var _getUser;
    if (getGlobalProperty("editingAsBrandToken")) {
        return true;
    }
    var roles = (_getUser = getUser()) === null || _getUser === void 0 ? void 0 : _getUser.roles;
    return areUserRolesAllowed(roles);
};
export var areUserRolesAllowed = function(roles) {
    if (!Array.isArray(roles)) {
        return false;
    }
    return intersection(allowedRoles, roles).length > 0;
};
